// removed by extract-text-webpack-plugin
module.exports = {"Logo":"src-components-Shared-Logo----Logo-module---Logo---bzuPt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Shared/Logo/Logo.module.css
// module id = 390
// module chunks = 114276838955818